import Header from '../components/Header/Header';
import Footer from "../components/Footer/footer";
import Registration_Window from "../components/Registration/Registration";

const Registration = () => {
  return (
    <div style={{ paddingTop: '80px' }}>
      <Header />
      <Registration_Window />
      <Footer />
    </div>
  );
};

export default Registration;
